import { Register } from '@unistocks/features/authentication/register/register';
import { t } from '@unistocks/localization';
import Head from 'expo-router/head';

export default function RegisterScreen() {
  return (
    <>
      <Head>
        <title>{`${t('AbpUi::Register')} | Unistocks`}</title>
      </Head>
      <Register />
    </>
  );
}
